import React from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import BlogsDetailsImage from "../assets/images/blog-detail-img.png";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useBlogDetails } from "../hooks/useBlogDetails";
import { ASSETS_URL } from "../api/constants";
import UserIcon from '../assets/images/user-1.svg';
import CalendarIcon from '../assets/images/calendar.svg';
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'
import { formatDate } from "../utils/date";

function BlogsDetails() {
  const { slug } = useParams();
  const { blog, loading, error } = useBlogDetails(slug);
  
  // Get the current URL (don't encode the entire URL)
  const currentUrl = window.location.href;
  
  // Function to handle Facebook share
  const shareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
    console.log('Sharing on Facebook:', url);
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle X/Twitter share
  const shareOnX = () => {
    const text = encodeURIComponent(blog?.title || 'Check out this blog post');
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(currentUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle LinkedIn share
  const shareOnLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle Instagram share (copy link method)
  const shareOnInstagram = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert('Link copied! You can now paste it in your Instagram post or story.');
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(`Please copy this link manually: ${currentUrl}`);
    }
  };
  
  // Function to handle YouTube share (copy link method)
  const shareOnYouTube = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert('Link copied! You can now paste it in your YouTube video description or community post.');
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(`Please copy this link manually: ${currentUrl}`);
    }
  };
  
  return (
    <>
      <div className="main blog-details-page">
        <Header />
        <section className="blog-details-section common-padding">
          <Container>
            <Row>
              <Col lg={8} md={12}>
                <article className="blog-article">
                  <div className="article-header">
                    <span className="category-badge">{blog?.category_name}</span>
                    <h1 className="article-title">{blog?.title}</h1>
                    <p className="article-subtitle">{blog?.meta_description}</p>
                  </div>
                  <div className="featured-image">
                    <img 
                      src={blog?.imageUrl ? ASSETS_URL + blog.imageUrl : blog?.image ? ASSETS_URL + blog.image : BlogsDetailsImage}
                      alt={blog?.title || 'Blog image'} 
                    />
                  </div>
                  <div className="article-meta">
                    <div className="author-info">
                        <img src={UserIcon} alt="John Doe" />
                      <span className="author-name">{blog?.created_by_first_name} {blog?.created_by_last_name}</span>
                    </div>
                    <div className="author-info">
                        <img src={CalendarIcon} alt="27 Apr 2025" />
                      <span className="author-name">{formatDate(blog?.created_at)}</span>
                    </div>
                    
                    <div className="social-share">
                      <ul>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnFacebook(); }}>
                            <img src={Facebook} alt="Facebook" />
                          </a>
                        </li> 
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnX(); }}>
                            <img src={X} alt="X" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnInstagram(); }}>
                            <img src={Instagram} alt="Instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnYouTube(); }}>
                            <img src={YouTube} alt="YouTube" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnLinkedIn(); }}>
                            <img src={LinkedIn} alt="LinkedIn" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Article Content */}
                  <div className="article-content">
                    {loading && <p>Loading blog...</p>}
                    {!loading && error && <p className="text-danger">{error}</p>}
                    {!loading && !error && !blog && <p>No blog found.</p>}

                    {!loading && !error && blog && (
                      <>
                        {blog.description ? (
                          <div dangerouslySetInnerHTML={{ __html: blog.description }} />
                        ) : (
                          <p>No blog content is available.</p>
                        )}
                      </>
                    )}
                  </div>
                </article>
              </Col>

              {/* Sidebar */}
              {blog?.related_blogs && blog.related_blogs.length > 0 && (
              <Col lg={4} md={12}>
                <aside className="blog-sidebar">
                  <h3>Related Blogs</h3>
                  <div className="sidebar-widget">
                    <ul className="related-blogs-list">
                      {blog?.related_blogs.map((related) => (
                        <li key={related.id} className="related-blog-item">
                          <Link to={`/blogs-details/${related?.slug || related.id}`} className="blog-link">
                            <span>{related.id}</span>
                            {related.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </Col>
              )}
            </Row>
          </Container>
        </section>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default BlogsDetails;